import type { PropsWithChildren } from "react"

import { AppContent } from "@/components/app-content"
import { AppShell } from "@/components/app-shell"
import { AppSidebar } from "@/components/app-sidebar"
import { SidebarTrigger } from "@/components/ui/sidebar"

export default function AppLayout({
  title,
  actions,
  children,
}: PropsWithChildren<{ title: string; actions?: React.ReactNode }>) {
  return (
    <AppShell variant="sidebar">
      <AppSidebar />
      <AppContent variant="sidebar" className="overflow-x-hidden">
        <header className="border-sidebar-border/50 flex h-16 shrink-0 items-center justify-between gap-2 border-b px-6 md:px-4">
          <div className="flex items-center gap-2">
            <SidebarTrigger className="-ml-1 md:hidden" />
            <h1 className="text-[26px] font-semibold leading-tight">{title}</h1>
          </div>
          {actions}
        </header>
        <div className="flex h-full min-h-0 flex-1 flex-col gap-4 overflow-y-auto p-6 md:p-4">
          {children}
        </div>
      </AppContent>
    </AppShell>
  )
}
